import { useParams } from '@tanstack/react-router'

import { isUuid } from '@/lib/entity'

// The selected entity id is carried in the `/$entityId/...` route segment — the
// single source of truth for "which entity am I acting on". Read it through this
// hook, never `useParams` directly, so the mechanism can change without touching
// every consumer. Returns null on routes with no entity segment (e.g. `/`).
export function useSelectedEntityId(): string | null {
  const { entityId } = useParams({ strict: false })
  return entityId && isUuid(entityId) ? entityId.toLowerCase() : null
}
